/*
**************************** 
홈페이지 공지 찾기
*****************************
*/

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function BoardSearch(props) {
    const pathData = useParams();
    const [find, setFind] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (pathData.listType === "list") {
            setFind("");
        } else {
            setFind(pathData.listType);
        }
    }, [pathData.listType])

    return (
        <div className="container">
            <div id="board-search">
                <div className="search-window">
                    <form action="">
                        <div className="search-wrap">
                            <label htmlFor="search" className="blind">공지사항 내용 검색</label>
                            <input id="search" type="search" name="find" value={find} placeholder="검색어를 입력해주세요." onChange={(e) => {
                                setFind(e.target.value);
                            }}></input>
                            <button type="button" className="btn btn-dark" onClick={() => {
                                if (find !== undefined && find !== "")
                                    navigate("/community/notice/1/" + find);
                            }}>검색</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}